import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import TransportationVehicles from './sections/TransportationVehicles'
import TransportationTravels from './sections/TransportationTravels'
import TransportationGeneral from './sections/TransportationGeneral'

export default function AddTransportationContent(props: any): JSX.Element {
  const [content, setContent] = useState<string>('General')
  const { t } = useTranslation()
  const [id, setId] = useState<number | null>(null)
  return (
    <div className="hotels-container ">
      <div className="navHotelContent w-full conteiner">
        <div className="navHotel w-fit m-auto flex rounded-2xl border-x border-y	 border-gray-300  px-3 justify-between ">
          <button
            type="button"
            onClick={props.mode ? () => setContent('General') : undefined}
            className={`me-2 ${
              !props.mode && 'cursor-not-allowed'
            } ms-2 px-1 py-[6px] text-sm relative ${content === 'General' ? 'active' : ''}`}>
            {t('General')}
          </button>
          <button
            type="button"
            onClick={props.mode ? () => setContent('Vehicles') : undefined}
            className={`me-2 ${
              !props.mode && 'cursor-not-allowed'
            }   ms-2 px-1 py-[6px] text-sm relative ${content === 'Vehicles' ? 'active' : ''}`}>
            {t('Vehicles')}
          </button>
          <button
            type="button"
            onClick={props.mode ? () => setContent('Travels') : undefined}
            className={`me-2 ${
              !props.mode && 'cursor-not-allowed'
            }  ms-2 px-1 py-[6px] text-sm relative ${content === 'Travels' ? 'active' : ''}`}>
            {t('Travels')}
          </button>
        </div>
      </div>
      {content === 'General' && (
        <TransportationGeneral mode={props.mode} setId={setId} setContent={setContent} />
      )}
      {content === 'Vehicles' && (
        <TransportationVehicles id={id} mode={props.mode} setContent={setContent} />
      )}
      {content === 'Travels' && (
        <TransportationTravels mode={props.mode} id={id} setContent={setContent} />
      )}
    </div>
  )
}
